import React from 'react';
import './styles/AppContainer.scss';
import WeatherForecast from './WeatherForecast';

const AppContainer = () => (
  <div className="app-container">
    <WeatherForecast />
  </div>
);

export default AppContainer;
